import React from 'react'
import { toast } from 'react-toastify'

/**
 * Options passed by default to Toast
 */
export const TOAST_DEFAULT_OPTIONS = {
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 10000,
}

/**
 * Render a warning Toast with past errors
 *
 * @param error
 * @returns {void}
 */
export function renderToastWarn(error) {
  toast.warn(renderToastErrors(error), TOAST_DEFAULT_OPTIONS)
}

/**
 * Renders a Successful Toast with a Message
 *
 * @param msg
 * @returns {void}
 */
export function renderToastSuccessMsg(msg) {
  toast.success(msg, TOAST_DEFAULT_OPTIONS)
}

/**
 * Monta o nó que contém a aparência dos erros
 *
 * @param error
 * @returns {HTMLElement}
 */
function renderToastErrors(error) {
  return (
    <div>
      <span>
        {error.message
          ? error.message.dsMessage || error.message
          : error && error.toString()}
      </span>
      {!!error.fields && <ul>{error.fields.map(renderToastErrorsFields)}</ul>}
      {!!error.data && <ul>{error.data.map(renderToastErrorsData)}</ul>}
    </div>
  )
}

/**
 * Assemble the node of each field that has error
 *
 * @param fieldError
 * @returns {HTMLElement}
 */
function renderToastErrorsFields(fieldError) {
  return <li key={fieldError.naField}>{fieldError.dsDetail}</li>
}

/**
 * Assemble the node of each field that has error
 *
 * @param dataError
 * @returns {HTMLElement}
 */
function renderToastErrorsData(dataError, index) {
  return <li key={index}>{dataError.message}</li>
}
